// =============================================
// src/components/HeroDecor.jsx
// =============================================

import React from "react";

const HeroDecor = () => (
  <>
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 0,
        background:
          "radial-gradient(600px 300px at 10% -10%, rgba(59,130,246,.20), transparent 70%)," +
          "radial-gradient(500px 250px at 90% 10%, rgba(16,185,129,.20), transparent 70%)",
      }}
    />
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 0,
        backgroundImage:
          "linear-gradient(rgba(255,255,255,.06) 1px, transparent 1px)," +
          "linear-gradient(90deg, rgba(255,255,255,.06) 1px, transparent 1px)",
        backgroundSize: "28px 28px",
        WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,.8), rgba(0,0,0,0.2))",
        maskImage: "linear-gradient(to bottom, rgba(0,0,0,.8), rgba(0,0,0,0.2))",
      }}
    />
  </>
);

export default HeroDecor;
